import { useEffect, type ReactNode } from "react";
import { Outlet, useParams } from "react-router";
import { getCustomer } from "@data/customers";
import { useAccessControl } from "@hooks/useAccessControl";
import { AccessDeniedPage } from "@pages/AccessDeniedPage";

type Props = {
  children?: ReactNode;
};

export function AccessGate({ children }: Props) {
  const { customer: customerId } = useParams<{ customer: string }>();
  const customer = customerId ? getCustomer(customerId) : undefined;

  const { hasAccess, checkAndSetToken } = useAccessControl(
    customer?.id ?? "",
    customer?.accessTokens ?? [],
    customer?.accessExpiry ?? new Date(),
  );

  useEffect(() => {
    checkAndSetToken();
  }, [checkAndSetToken]);

  if (!customer || !hasAccess) {
    return <AccessDeniedPage />;
  }

  return children ?? <Outlet />;
}
